<template>
  <div class="ten-image-viewer-wrapper" v-if="realVisible || !destroy">
    <transition
      name="ten-fade-in"
      appear
    >
      <div
        v-show="visible"
        ref="ten-image-viewer"
        class="ten-image-viewer"
        :style="{ 'z-index': zIndex }"
      >
        <div class="ten-image-viewer__mask" />
        <transition name="ten-image-viewer__slide-down">
          <div
            v-if="_isHeaderShow"
            class="ten-image-viewer__header"
            @mouseenter="showActionBarsHandler"
            @mouseout="hideActionBarsHandler"
          >
            <div
              v-if="!simple"
              class="ten-image-viewer__header-indexes"
            >
              {{ index+1 }} <span style="color: rgba(255,255,255,.6)">/ {{ list.length }}</span>
            </div>
            <span
              class="ten-image-viewer__header-close"
              @click="closeViewer"
            >
              <ten-icon icon="clear" />
            </span>
          </div>
        </transition>
        <template v-if="!_isOnlyOne && !simple">
          <span
            class="ten-image-viewer__btn ten-image-viewer__btn-prev"
            :class="{ 'ten-image-viewer__btn--disabled': !infinite && _isFirstIndex }"
            @click="goToPrev()"
          >
            <ten-icon icon="left" />
          </span>
          <span
            class="ten-image-viewer__btn ten-image-viewer__btn-next"
            :class="{ 'ten-image-viewer__btn--disabled': !infinite && _isLastIndex }"
            @click="goToNext()"
          >
            <ten-icon icon="right" />
          </span>
        </template>
        <transition name="ten-image-viewer__slide-up">
          <div
            v-if="_isFooterShow"
            class="ten-image-viewer__footer"
            :style="_footerHeightStyle"
            @mouseenter="showActionBarsHandler"
            @mouseout="hideActionBarsHandler"
          >
            <div class="ten-image-viewer__footer-actions">
              <span
                class="ten-image-viewer__action ten-image-viewer__action-zoomin"
                @click="actionHandler('zoomin')"
              >
                <ten-icon icon="zoom_in" />
              </span>
              <span
                class="ten-image-viewer__action ten-image-viewer__action-zoomout"
                @click="actionHandler('zoomout')"
              >
                <ten-icon icon="zoom_out" />
              </span>
              <span
                class="ten-image-viewer__action ten-image-viewer__action-scan ten-image-viewer__action--divided"
                @click="getOriginalScale"
              >
                <ten-icon icon="scan" /> {{ t('imageViewer.size') }}
              </span>
              <span class="ten-image-viewer__action ten-image-viewer__action-download">
                <a
                  :href="_currentImg"
                  target="_blank"
                  download
                ><ten-icon icon="download" /> {{ t('imageViewer.save') }}</a>
              </span>
              <span
                class="ten-image-viewer__action ten-image-viewer__action-thumb ten-image-viewer__action--divided"
                @click="isThumbsShow = !isThumbsShow"
                v-if="!simple"
              >
                {{ isThumbsShow ? t('imageViewer.fold') : t('imageViewer.expand') }}
              </span>
            </div>
            <transition name="ten-image-viewer__slide-down">
              <div
                class="ten-image-viewer__footer-thumbs"
                :style="_thumbsContainerStyle"
                v-show="isThumbsShow"
              >
                <ul :style="_thumbsListStyle">
                  <li
                    class="ten-image-viewer__footer-thumbs-item"
                    :style="_thumbItemStyle"
                    v-for="(url, i) in list"
                    :class="{'ten-image-viewer__footer-thumbs-item--active': i === index}"
                    :key="`thumb-${i}`"
                    @click="goToIndex(i)"
                  >
                    <img :src="url">
                  </li>
                </ul>
              </div>
            </transition>
          </div>
        </transition>

        <transition
          name="ten-flow-in"
          appear
        >
          <div
            v-show="visible"
            :style="_imageWrapperStyle"
            ref="imgWrapper"
            class="ten-image-viewer__image"
          >
            <template v-for="(url, i) in list">
              <img
                v-if="i === index"
                ref="img"
                class="ten-image-viewer__image-img"
                :key="i"
                :src="_currentImg"
                :style="_imgStyle"
                @load="imgLoadedHandler"
                @error="imgErrorHandler"
                @mousedown="imgMouseDownHandler"
                @mouseenter="showActionBarsHandler"
                @mouseout="hideActionBarsHandler"
              >
            </template>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>

import DomHelper from '../scripts/utils/dom-helper';
import TenIcon from '../icon';
import { localMixin } from '../config';

const name = 'ten-image-viewer';

let prevOverflow = '';
let actionBarsShowTimer = null;

const thumbsSetting = {
  containerWidth: 720,
  itemWidth: 58,
  itemMargin: 8,
};

export default {
  name,
  components: {
    TenIcon,
  },
  mixins: [localMixin],
  model: {
    prop: 'index',
    event: 'change',
  },
  props: {
    /**
     * 当前 index 值
     * @model index
     */
    index: {
      type: Number,
      default: 0,
    },
    /**
     * 初始 index 值
     */
    defaultIndex: Number,
    /**
     * 是否显示，支持 .sync 修饰符，对应事件 update:visible
     */
    visible: {
      type: Boolean,
      default: false,
    },
    /**
     * 图片 url 列表
     */
    list: {
      type: Array,
      default: () => [],
    },
    /**
     * 图片查看器容器 z-index
     */
    zIndex: {
      type: Number,
      default: 1000,
    },
    /**
     * 显示底部预览图列表
     */
    showPreview: {
      type: Boolean,
      default: false,
    },
    /**
     * 是否为简易预览模式
     */
    simple: {
      type: Boolean,
      default: false,
    },
    /**
     * 是否可循环切换 index 值
     */
    infinite: {
      type: Boolean,
      default: false,
    },
    /**
     * 关闭时是否销毁
     */
    destroy: {
      type: Boolean,
      default: true,
    },
    /**
     * 挂载节点，默认 body
     */
    attach: {
      type: [String, Function, Element],
      default: 'body',
    },
  },

  data() {
    return {
      loading: false,
      realVisible: this.visible,

      isThumbsShow: this.showPreview,
      showActionBars: false,

      transform: {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: true,
      },
    };
  },

  computed: {
    _isOnlyOne() {
      return this.list.length <= 1;
    },
    _isFirstIndex() {
      return this.index === 0;
    },
    _isLastIndex() {
      return this.index === this.list.length - 1;
    },
    _currentImg() {
      return this.list[this.index];
    },
    _imgStyle() {
      const { scale, deg, offsetX, offsetY, enableTransition } = this.transform;
      const style = {
        transform: `scale(${scale}) rotate(${deg}deg)`,
        transition: enableTransition ? 'transform .3s' : '',
        'margin-left': `${offsetX}px`,
        'margin-top': `${offsetY}px`,
      };
      return style;
    },
    _thumbsContainerStyle() {
      return {
        width: `${thumbsSetting.containerWidth}px`,
      };
    },
    _thumbItemStyle() {
      return {
        width: `${thumbsSetting.itemWidth}px`,
        marginRight: `${thumbsSetting.itemMargin}px`,
      };
    },
    _thumbsListStyle() {
      if (!this.showPreview) return;
      const { index, list } = this;
      const { containerWidth, itemWidth, itemMargin } = thumbsSetting;

      const itemCount = list.length;
      const maxCount = parseInt(containerWidth / (itemWidth + itemMargin), 10);
      const listWidth = (itemWidth * itemCount) + (itemMargin * (itemCount - 1));

      let offset;
      if (itemCount <= maxCount) {
        offset = (containerWidth - listWidth) / 2;
      } else {
        const leftPos = (index * (itemWidth + itemMargin)) + (itemWidth / 2);
        offset = (containerWidth / 2) - leftPos;
        if (offset > 0) offset = 0;
        if (offset < containerWidth - listWidth) offset = containerWidth - listWidth;
      }

      return {
        transform: `translate(${offset}px, 0)`,
        width: `${listWidth}px`,
      };
    },
    _footerHeightStyle() {
      return {
        height: this.isThumbsShow ? '92px' : '48px',
      };
    },
    _imageWrapperStyle() {
      return {
        // bottom: this.isThumbsShow ? '92px' : '48px'
      };
    },
    // 简易模式下 hover 操作显示头部底部
    _isHeaderShow() {
      if (!this.simple) return true;
      return this.showActionBars;
    },
    // 简易模式下 hover 操作显示头部底部
    _isFooterShow() {
      if (!this.simple) return true;
      return this.showActionBars;
    },
  },

  watch: {
    index: {
      handler() {
        this.resetImgTransform();
      },
    },
    _currentImg() {
      this.$nextTick(() => {
        const [$img] = this.$refs.img;
        if (!$img.complete) {
          this.loading = true;
        }
      });
    },
    visible(val) {
      if (val) {
        this.realVisible = true;
        this.appendToDom();
        this.$nextTick(() => {
          this.install();
        });
      } else {
        this.uninstall();
        setTimeout(() => {
          this.realVisible = false;
        }, 300);
      }
    },
  },

  mounted() {
    prevOverflow = document.body.style.overflow;
    if (this.visible) this.install();

    const $imageViewer = this.$refs['ten-image-viewer'];
    if ($imageViewer) $imageViewer.focus();
  },

  beforeDestroy() {
    this.uninstall();
  },

  destroyed() {
    try {
      this.$el && document.body.removeChild(this.$el);
    } catch (e) {}
  },

  methods: {
    appendToDom() {
      if (this.$el) {
        let container = null;
        if (typeof this.attach === 'function') {
          container = this.attach(this.$el.parentNode);
        } else if (typeof this.attach === 'string') {
          container = document.querySelector(this.attach);
        } else {
          container = this.attach;
        }
        if (!container) throw Error('attch must be a valid dom');
        container.appendChild(this.$el);
      }
    },
    closeViewer() {
      clearTimeout(actionBarsShowTimer);
      /**
       * 查看器关闭
       */
      this.$emit('close');
      /**
       * 查看器 visible 变更
       * @param {Boolean} visible 显示与否
       */
      this.$emit('update:visible', false);
    },

    // 初始化
    install() {
      this.setBodyCalcSize();
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.keyDownHandler);
      const $imgWrapper = this.$refs.imgWrapper;
      const wheelEvt = this.getWheelEvt();
      if ($imgWrapper) $imgWrapper.addEventListener(wheelEvt, this.mouseWheelHandler);
      // document.addEventListener(wheelEvt, this.mouseWheelHandler);
    },

    // 移除事件
    uninstall() {
      document.body.style.overflow = prevOverflow;
      this.setBodyCalcSize(true);
      document.removeEventListener('keydown', this.keyDownHandler);
      const $imgWrapper = this.$refs.imgWrapper;
      const wheelEvt = this.getWheelEvt();
      if ($imgWrapper) $imgWrapper.removeEventListener(wheelEvt, this.mouseWheelHandler);
      // document.removeEventListener(wheelEvt, this.mouseWheelHandler);
    },

    getWheelEvt() {
      let wheelEvt;
      if ('onwheel' in document.createElement('div')) {
        wheelEvt = 'wheel'; // Modern browsers support "wheel"
      } else if (document.onmousewheel !== undefined) {
        wheelEvt = 'mousewheel'; // Webkit and IE support at least "mousewheel"
      } else {
        wheelEvt = 'DOMMouseScroll'; // let's assume that remaining browsers are older Firefox
      }
      return wheelEvt;
    },

    imgLoadedHandler() {
      this.loading = false;
    },
    imgErrorHandler(e) {
      this.loading = false;
      e.target.alt = '加载失败';
    },

    // 快捷键操作
    keyDownHandler(e) {
      const { keyCode } = e;
      switch (keyCode) {
        // ESC
        case 27:
          this.closeViewer();
          break;
        // LEFT_ARROW
        case 37:
          this.goToPrev();
          break;
        // UP_ARROW
        case 38:
          this.actionHandler('zoomin');
          break;
        // RIGHT_ARROW
        case 39:
          this.goToNext();
          break;
        // DOWN_ARROW
        case 40:
          this.actionHandler('zoomout');
          break;
      }
    },

    // 滚轮操作
    mouseWheelHandler(e) {
      const delta = -e.deltaY;
      if (delta > 0) {
        this.actionHandler('zoomin', {
          zoomRate: 0.015,
          enableTransition: false,
        });
      } else {
        this.actionHandler('zoomout', {
          zoomRate: 0.015,
          enableTransition: false,
        });
      }
    },

    // 拖拽操作
    imgMouseDownHandler(e) {
      if (this.loading || e.button !== 0) return;
      const { offsetX, offsetY } = this.transform;
      const startX = e.pageX;
      const startY = e.pageY;
      this._dragHandler = (ev) => {
        this.transform.offsetX = offsetX + ev.pageX - startX;
        this.transform.offsetY = offsetY + ev.pageY - startY;
      };
      document.addEventListener('mousemove', this._dragHandler);
      document.addEventListener('mouseup', () => {
        document.removeEventListener('mousemove', this._dragHandler);
      });
      e.preventDefault();
    },

    // 简易模式下 hover 操作
    showActionBarsHandler() {
      if (!this.simple) return false;
      clearTimeout(actionBarsShowTimer);
      this.showActionBars = true;
    },
    hideActionBarsHandler() {
      if (!this.simple) return false;
      clearTimeout(actionBarsShowTimer);
      actionBarsShowTimer = setTimeout(() => {
        this.showActionBars = false;
      }, 2500);
    },

    // 放大缩小操作
    actionHandler(action, options = {}) {
      if (this.loading) return;
      const { zoomRate, enableTransition } = {
        zoomRate: 0.2,
        enableTransition: true,
        ...options,
      };
      const { transform } = this;
      switch (action) {
        case 'zoomout':
          if (transform.scale > 0.2) {
            transform.scale = parseFloat((transform.scale - zoomRate).toFixed(3));
          }
          break;
        case 'zoomin':
          transform.scale = parseFloat((transform.scale + zoomRate).toFixed(3));
          break;
        default:
          break;
      }
      transform.enableTransition = enableTransition;
    },
    resetImgTransform() {
      this.transform = {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false,
      };
    },
    getOriginalScale() {
      if (this.loading) return;
      this.resetImgTransform();
    },

    // 切换操作
    goToPrev() {
      if (this._isFirstIndex && !this.infinite) return;
      const len = this.list.length;
      const index = (this.index - 1 + len) % len;
      this.$emit('change', index);
    },
    goToNext() {
      if (this._isLastIndex && !this.infinite) return;
      const len = this.list.length;
      const index = (this.index + 1) % len;
      this.$emit('change', index);
    },
    goToIndex(i) {
      /**
       * 图片 index 值变更
       * @param {Number} index 当前 index 值
       */
      this.$emit('change', i);
    },

    setBodyCalcSize(clear) {
      const bodyIsScroll =        document.body.scrollHeight
          > (window.innerHeight || document.documentElement.clientHeight)
        && window.innerWidth > document.body.offsetWidth;

      if (!bodyIsScroll) {
        return;
      }
      if (clear) {
        document.body.style.position = '';
        document.body.style.width = '';
        return;
      }
      const calcSize = DomHelper.getBrowserScrollSize();

      if (calcSize) {
        document.body.style.position = 'relative';
        document.body.style.width = `calc(100% - ${calcSize}px)`;
      }
    },
  },
};
</script>
